<template>
	<div v-if="single" :id="attributeName + '__area'">
		<div data-attribute-type="single" :class="getColumnClass()" data-attribute-index="0">
			<div :class="SINGLE_ATTRIBUTE">
				<div class="col-sm-5">
					<AttributeLabel
						:attributeName="attributeName"
						:localizedTitle="localizedTitle"
						:is-primary="isPrimary"
						:is-multiple="isMultiple"
						:max-count="maxCount"
						:sl-attribute="false"
						:enable-copy-attribute-name="enableCopyAttributeName"
						:expression="expression"
						:locked-edit="lockedEdit"
						@recalculate="recalculateAttribute"
					/>
				</div>
				<div class="col-sm-7">
					<input :id="attributeName" type="text"
						   :class="'textInput-split attribute-nm attribute-editor ' + defaultValClass"
						   v-model="attributeValue.val"
						   :disabled="lockedEdit">
					<button
						v-if="!lockedEdit"
						:class="'button_reset fa fa-times ' + defaultValClass"/>
					<select :id="'list__' + attributeName"
							:class="'select-split attribute-editor ' + defaultLockClass"
							v-model="attributeValue.mu"
							:disabled="lockedEdit">
						<option v-for="(value, key) in measurementUnits" :value="key">{{ key }}</option>
					</select>
				</div>
			</div>
		</div>
	</div>
	<div v-else data-attribute-type="single" :class="getColumnClass() + ' col-sm-7'">
		<div v-for="(value, key) in attributeValue" :key="key" :data-attribute-index="key">
			<div :class="SINGLE_ATTRIBUTE">
				<input :id="attributeName + '__' + key" type="text"
					   :class="'textInput-split attribute-nm attribute-editor multiple-hotkey ' + defaultValClass"
					   v-model="attributeValue[key].val"
					   :disabled="lockedEdit">
				<button
					v-if="!lockedEdit"
					:class="'button_reset fa fa-times ' + defaultValClass"/>
				<button class="button_minus fa fa-minus" tabindex="-1" @click="deleteAttribute"/>
				<select :id="'list__' + attributeName + '__' + key"
						:class="'select-split attribute-editor multiple-hotkey ' + defaultLockClass"
						v-model="attributeValue[key].mu"
						:disabled="lockedEdit">
					<option v-for="(value, key) in measurementUnits" :value="key">{{ key }}</option>
				</select>
			</div>
		</div>
	</div>
</template>

<script>
import AttributeLabel from './AttributeLabel'
import defaultClassManager from '../../mixins/defaultClassManager'
import { formatNumber } from 'utils/format'
import { attributeChangesRegister } from '@/core/item_assistance/unsavedDataManager'
import { expressionCalculate } from '@/mixins/expressionCalculate'
import { UPDATE_ITEM_DATA } from 'actions/configurations'

export default {
	components: {
		AttributeLabel
	},
	mixins: [defaultClassManager, expressionCalculate],
	name: 'NMAttributeEditorComponent',
	props: [
		'attributeName',
		'localizedTitle',
		'isMultiple',
		'isPrimary',
		'maxCount',
		'defaultValue',
		'defaultLock',
		'colspan',
		'measurementUnits',
		'measurementUnitType',
		'enableCopyAttributeName',
		'expression',
		'lockedEdit'
	],
	data () {
		return {
			single: !this.isMultiple,
			SINGLE_ATTRIBUTE: 'single-attribute',
      attributeValue: {}
		}
	},
	computed: {
		/*attributeValue: {
			get () {

			},
			set (newValue) {

			}
		},*/
		itemData: function () {
			return this.$store.getters.getItemData
		},
		hasDefaultValPart () {
			return this.defaultValue.val != null
		},
		hasDefaultMuPart () {
			return this.defaultValue.mu != null
		},
		defaultValClass () {
			if (this.lockedEdit) {
				return ''
			} else if (this.hasDefaultValPart) {
				return this.DEFAULT_LOCK_CLASS + ' ' + this.DEFAULT_VALUE_CLASS
			}
			return ''
		},
		defaultLockClass () {
			if (this.lockedEdit) {
				return ''
			} else if (this.hasDefaultMuPart) {
				return this.DEFAULT_LOCK_CLASS
			}
		}
	},
  watch: {
    'attributeValue.val': function (newValue) {
      this.$set(this.itemData, this.attributeName, {'val': Number(newValue), 'mu': this.attributeValue.mu })
      this.$store.dispatch(UPDATE_ITEM_DATA, this.itemData).then(() => {})
    }
  },
	methods: {
		format: function (value) {
			if (value) {
				return formatNumber(String(value), this.$store.getters.getPerson)
			} else {
				return value
			}
		},
		deleteAttribute: function (e) {
			let key = $(e.target).parent().parent().attr('data-attribute-index')
			if (key > 0) {
				this.$delete(this.itemData, key)
				this.$nextTick(() => {
					attributeChangesRegister(this.attributeName)
				})
			}
		},
    getAttributeValue: function () {
      if (this.itemData[this.attributeName]) {
        let itemData = this.itemData[this.attributeName]
        itemData.val = this.format(itemData.val)
        if (!itemData.mu) {
          itemData.mu = this.defaultValue.mu
        }
        return itemData
      } else if (this.hasDefaultValPart) {
        return {
          val: this.defaultValue.val,
          mu: this.defaultValue.mu
        }
      } else {
        return !this.isMultiple ? {
          val: this.format(this.expressionCalculate()),
          mu: this.defaultValue.mu
        } : [{
          val: this.format(this.expressionCalculate()),
          mu: this.defaultValue.mu
        }]
      }
    }
	},
  mounted () {
    this.attributeValue = this.getAttributeValue();
  }
}
</script>

<style scoped>

</style>
